// src/components/Navbar.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { WEDDING_CONFIG } from '../config';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { name: 'Home', path: '/home' },
    { name: 'Entourage', path: '/entourage' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Upload', path: '/upload' },
    { name: 'Venue', path: '/venue' },
  ];

const toggleMenu = () => {
  setIsOpen(!isOpen);
  
  if (!isOpen) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'unset';
  }
};

const closeMenu = () => {
  setIsOpen(false);
  document.body.style.overflow = 'unset';
};
  return (
    <>
      <nav style={styles.navbar}>
        <Link to="/home" style={styles.logo} onClick={closeMenu}>
          {WEDDING_CONFIG.bride.split(' ')[0]} & {WEDDING_CONFIG.groom.split(' ')[0]}
        </Link>

        {/* Hamburger Menu Button - Mobile Only */}
        <button 
          style={styles.hamburger} 
          onClick={toggleMenu}
          aria-label="Toggle menu"
          className="hamburger-btn"
        >
          <span style={{...styles.hamburgerLine, ...(isOpen && styles.hamburgerLineOpen1)}}></span>
          <span style={{...styles.hamburgerLine, ...(isOpen && styles.hamburgerLineOpen2)}}></span>
          <span style={{...styles.hamburgerLine, ...(isOpen && styles.hamburgerLineOpen3)}}></span>
        </button>

        {/* Desktop Menu - Always Visible on Desktop */}
        <ul style={styles.desktopMenu} className="desktop-menu">
          {menuItems.map((item) => (
            <li key={item.path} style={styles.menuItem}>
              <Link 
                to={item.path} 
                style={{
                  ...styles.link,
                  ...(location.pathname === item.path && styles.activeLink)
                }}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <>
          <div style={styles.overlay} onClick={closeMenu}></div>
          <div style={styles.mobileMenu} className="mobile-menu">
            <ul style={styles.mobileMenuList}>
              {menuItems.map((item) => (
                <li key={item.path} style={styles.mobileMenuItem}>
                  <Link 
                    to={item.path} 
                    style={{
                      ...styles.mobileLink,
                      ...(location.pathname === item.path && styles.activeMobileLink)
                    }}
                    onClick={closeMenu}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
};

const styles = {
  navbar: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    padding: '1rem 5%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: 1000,
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  },
  logo: {
    fontSize: '1.3rem',
    fontWeight: '700',
    color: WEDDING_CONFIG.colors.primary,
    textDecoration: 'none',
    fontFamily: "'Playfair Display', serif",
    whiteSpace: 'nowrap',
    zIndex: 1002,
  },
  hamburger: {
    display: 'none',
    flexDirection: 'column',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0.5rem',
    zIndex: 1002,
  },
  hamburgerLine: {
    width: '25px',
    height: '3px',
    background: WEDDING_CONFIG.colors.primary,
    margin: '3px 0',
    transition: 'all 0.3s',
    borderRadius: '3px',
  },
  hamburgerLineOpen1: {
    transform: 'rotate(45deg) translate(7px, 7px)',
  },
  hamburgerLineOpen2: {
    opacity: 0,
  },
  hamburgerLineOpen3: {
    transform: 'rotate(-45deg) translate(7px, -7px)',
  },
  desktopMenu: {
    display: 'flex',
    gap: '2rem',
    listStyle: 'none',
    alignItems: 'center',
    margin: 0,
    padding: 0,
  },
  menuItem: {
    margin: 0,
  },
  link: {
    textDecoration: 'none',
    fontWeight: '500',
    fontSize: '1rem',
    color: '#333',
    transition: 'color 0.3s',
    cursor: 'pointer',
  },
  activeLink: {
    color: WEDDING_CONFIG.colors.primary,
    fontWeight: '600',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: 998,
  },
  mobileMenu: {
    position: 'fixed',
    top: '70px',
    left: 0,
    right: 0,
    background: 'white',
    padding: '1rem 0',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    zIndex: 999,
    maxHeight: 'calc(100vh - 70px)',
    overflowY: 'auto',
  },
  mobileMenuList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  mobileMenuItem: {
    borderBottom: '1px solid #eee',
  },
  mobileLink: {
    display: 'block',
    padding: '1rem 2rem',
    textDecoration: 'none',
    fontSize: '1.1rem',
    color: '#333',
    fontWeight: '500',
    transition: 'background 0.3s, color 0.3s',
  },
  activeMobileLink: {
    background: `${WEDDING_CONFIG.colors.primary}15`,
    color: WEDDING_CONFIG.colors.primary,
    fontWeight: '600',
    borderLeft: `4px solid ${WEDDING_CONFIG.colors.primary}`,
  },
};

export default Navbar;